import { Pipe, PipeTransform } from '@angular/core';
import { TokenStorageService } from 'src/app/shared/services/token-storage.service';
import { ProgramType } from 'src/app/shared/enums/program-type.enum';

@Pipe({
  name: 'trainerToOtherRoles',
  standalone: false
})
export class TrainerToOtherRolesPipe implements PipeTransform {
  constructor(private readonly tokenStorage: TokenStorageService) {}

  public transform(text: string, type: ProgramType = null): string {
    if (type === null) {
      type = this.tokenStorage.userInfo.CurrentProgram.Type;
    }

    switch (type) {
      case ProgramType.FieldTraining:
        return text;
      case ProgramType.PerformanceEvaluation:
        return text.replace(/Trainer/g, 'Supervisor').replace(/trainer/g, 'supervisor');
      case ProgramType.ProbationaryPeriod:
        return text.replace(/Trainer/g, 'Supervisor').replace(/trainer/g, 'supervisor');
      case ProgramType.Mentoring:
        return text.replace(/Trainer/g, 'Mentor').replace(/trainer/g, 'mentor');
    }
  }
}
